import { render } from "./normgrouptable.vue?vue&type=template&id=7d815f34&scoped=true"
import script from "./normgrouptable.vue?vue&type=script&lang=js"
export * from "./normgrouptable.vue?vue&type=script&lang=js"

import "./normgrouptable.vue?vue&type=style&index=0&id=7d815f34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d815f34"]])

export default __exports__